import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './PhotoOverlay.module.css.mjs';
import { photoOverlayDirectionMap } from './PhotoOverlay.utils.mjs';

const PhotoOverlay = polymorphicFactory(
  (props, ref) => {
    const { component = "div", className, opacity, direction, style, ...rest } = props;
    const deg = direction ? photoOverlayDirectionMap[direction] : "tint";
    const bg = direction === "tint" ? `rgb(0 0 0 / ${opacity ?? 0}%)` : `linear-gradient(${deg}, rgb(0 0 0 / ${opacity}%) 0%, rgb(0 0 0 / 0%) 100%)`;
    const classNames = clsx("kohler-photo-overlay-root", className, classes.root);
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        className: classNames,
        component,
        ref,
        style: { "--photo-overlay-bg": bg, ...style },
        ...rest
      }
    );
  }
);

export { PhotoOverlay };
